export const SET_IS_OCCASION = 'SET_IS_OCCASION';

export type SetIsOccasionAction = {
	type: typeof SET_IS_OCCASION;
	payload: boolean;
};

export type IsOccasionActionTypes = SetIsOccasionAction;
